import {
  NewRegistrationHighSchool,
  NewRegistrationAttachment,
  NewRegistrationUniversity,
  NewRegistrationProject,
  NewRegistrationLanguage,
  NewRegistrationWorkExperience,
  NewRegistrationSkills,
} from './new-registration.model';
import { Address } from './address.model';
import { AllCVOptionsFromDB } from './cv-options.model';

export class AllCVOptionsFromDBResponse {
  body?: AllCVOptionsFromDB;
  message?: string;
  status?: number;
}

export class LongCvResponse {
  body?: FinalLongCvModel;
  message?: string;
  status?: number;
}

export class FinalLongCvModel {
  id?: number;
  gender!: string;
  title?: string;
  titleAfterName?: string;
  birthDate!: Date;
  email!: string;
  telephone!: string;
  // from confluesne?
  // nationality!: string;
  // status!: boolean;
  // experience!: number;
  address!: Address;
  highSchoolEducations!: NewRegistrationHighSchool[];
  universityEducations!: NewRegistrationUniversity[];
  // courses!: NewRegistrationCourse[];
  projects!: NewRegistrationProject[];
  languages!: NewRegistrationLanguage[];
  workExperiences!: NewRegistrationWorkExperience[];
  skills!: NewRegistrationSkills[];
  candidateAttachment!: NewRegistrationAttachment[];
}

export class PersonalInfoModel {
  id?: number;
  gender?: string;
  title?: string;
  titleAfterName?: string;
  birthDate?: Date;
  email?: string;
  telephone?: string;
  address?: Address;
}

export class UpdatePersonalInfoModel {
  aiMatching?: boolean;
  longCV?: PersonalInfoModel;
}

export class UpdateHighSchoolEducationModel {
  longCVId?: number;
  highSchoolEducations?: NewRegistrationHighSchool[];
}

export class UpdateUniversityEducationModel {
  longCVId?: number;
  universityEducations?: NewRegistrationUniversity[];
}

export class UpdateProjectModel {
  longCVId?: number;
  projects?: NewRegistrationProject[];
}

export class UpdateLanguageModel {
  longCVId?: number;
  languages?: NewRegistrationLanguage[];
}

export class UpdateWorkExperienceModel {
  longCVId?: number;
  experiences?: NewRegistrationWorkExperience[];
}

export class UpdateSkillsModel {
  longCVId?: number;
  skills?: NewRegistrationSkills[];
}
